(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8024,7839],{

/***/ 2607:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[slug]",
      function () {
        return __webpack_require__(5939);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CollectionSection": function() { return /* reexport */ CollectionSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
;// CONCATENATED MODULE: ./src/components/CollectionSection/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_collection_border_radius",
                label: "Border radius",
                type: "number",
                endAdornment: "px",
                default: theme.shape.borderRadius
            },
            {
                name: "theme_component_collection_background_color",
                label: "Background color",
                type: "color",
                default: "rgba(0, 0, 0, 0)"
            },
            {
                name: "theme_component_collection_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                default: 0,
                endAdornment: "px"
            },
            {
                name: "theme_component_collection_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
;// CONCATENATED MODULE: ./src/components/CollectionSection/CollectionSection.tsx








var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z, {
    target: "e7wqnia0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        borderRadius: theme.theme_component_collection_border_radius ? "".concat(theme.theme_component_collection_border_radius, "px") : theme.shape.borderRadius,
        backgroundColor: theme.theme_component_collection_background_color || "rgba(0, 0, 0, 0)",
        borderBottomWidth: theme.theme_component_collection_border_bottom_width ? "".concat(theme.theme_component_collection_border_bottom_width, "px") : 0,
        borderBottomColor: theme.theme_component_collection_border_bottom_color || theme.palette.divider,
        borderBottomStyle: "solid",
        "&:first-of-type": {
            marginTop: theme.spacing(0)
        },
        "&:last-of-type:not(:first-of-type)": {
            marginBottom: theme.spacing(0)
        }
    };
});
var CollectionSection = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useEditorHandlers("Collection Section"), other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/CollectionSection/index.ts



/***/ }),

/***/ 2430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ImageLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/ImageLoaderWrapper.tsx





/**
 * Calculates the proper height of an image with a custom width, preserving the original aspect ratio.
 *
 * @param originalHeight
 * @param originalWidth
 * @param newWidth
 */ function determineNewHeight(originalHeight, originalWidth, newWidth) {
    return Math.ceil(originalHeight / originalWidth * newWidth);
}
var ImageLoaderWrapper = function(props) {
    var height = props.height, width = props.width, grayscale = props.grayscale, format = props.format, layout = props.layout, alt = props.alt, _rszHeight = props.rszHeight, rszHeight = _rszHeight === void 0 ? true : _rszHeight, other = (0,_object_without_properties/* default */.Z)(props, [
        "height",
        "width",
        "grayscale",
        "format",
        "layout",
        "alt",
        "rszHeight"
    ]);
    var loader = function(loaderProps) {
        var q = loaderProps.quality, w = loaderProps.width, src = loaderProps.src;
        // if (/^https?:\/\//.test(src)) return src;
        // Can find the query properties here;
        // https://gitlab.azerdev.com/huz.byorbit/huz-media/-/blob/master/src/asset/index.js
        // Todo: HUZ2ERA-1106 - Seems our media server won't allow us to resize webp assets by ratio operation.
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&ar[r]=${width}x${height}&ar[w]=${w}`;
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&rsz[w]=${w}`;
        var url = "".concat(src.replace(/\/+$/, ""), "/?fmt=").concat(format || "webp", "&rsz[w]=").concat(w);
        if (rszHeight) {
            url += "&rsz[h]=".concat(determineNewHeight(height, width, w));
        }
        if (grayscale) url += "&gsc=".concat(grayscale);
        return url;
    };
    // Make sure we don't pass width and height when layout is set to 'fill'. Refer to Next/image docs.
    return layout === "fill" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        layout: layout,
        loader: loader
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        width: width,
        height: height,
        loader: loader
    }));
};

;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/index.ts



/***/ }),

/***/ 7405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ CollectionC; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(1567);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 4 modules
var AppContext = __webpack_require__(6242);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(8958);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(6336);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(9072);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 8 modules
var Card = __webpack_require__(6267);
// EXTERNAL MODULE: ./src/components/Title/index.ts + 2 modules
var Title = __webpack_require__(1546);
// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 1 modules
var BreadCrumbs = __webpack_require__(7082);
// EXTERNAL MODULE: ./src/components/CollectionSection/index.ts + 2 modules
var CollectionSection = __webpack_require__(7839);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(5613);
// EXTERNAL MODULE: ./src/contexts/CursorContext/index.tsx
var CursorContext = __webpack_require__(5888);
;// CONCATENATED MODULE: ./src/containers/CollectionC/CollectionC.tsx




















var CollectionC_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CarouselList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7397), __webpack_require__.e(7699)]).then(__webpack_require__.bind(__webpack_require__, 4905)).then(function(mod) {
        return mod.CarouselList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4905)
            ];
        }
    },
    ssr: false
});
var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* CardSkeleton */.q4, {
    target: "erimhfr0"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        aspectRatio: "16/9"
    };
});
var CollectionC = function(props) {
    var title = props.title, body = props.body, collection = props.collection, global = props.global, pageContext = props.pageContext;
    var t = (0,useTranslation/* useTranslation */.$)("collection_c").t;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)(), ref1 = ref.ref, inView = ref.inView;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var enabled = (0,CursorContext/* useCursorContext */.r)().enabled;
    var ref2 = appContext.useConfig(), assetUrl = ref2.assetUrl, componentOptions = ref2.componentOptions;
    var theme = (0,useTheme/* default */.Z)();
    var descriptionRef = react.useRef(null);
    var totalPreferredItems = 18;
    var totalItems = collection.games.length || 0;
    var itemsLeft = totalPreferredItems - totalItems;
    var emptyItems = itemsLeft < 0 ? 0 : itemsLeft;
    var cardType = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_carousel_card_type;
    var hideEmptyCards = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_empty_cards_hidden;
    var breaks = {
        xs: 6,
        sm: 4,
        md: 3,
        lg: 2
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                maxWidth: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                    breadcrumbs: pageContext.breadcrumbs,
                    hidden: componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_breadcrumb_hidden
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                        ref: ref1,
                        maxWidth: false,
                        disableGutters: false,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection.CollectionSection, {
                            sx: {
                                paddingBottom: theme.spacing(2)
                            },
                            children: [
                                title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h1",
                                    variant: "h1",
                                    disableGutters: true,
                                    children: title
                                }),
                                body && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionC_Typography, {
                                    ref: descriptionRef,
                                    variant: "body1",
                                    sx: {
                                        marginTop: theme.spacing(1.25),
                                        marginBottom: theme.spacing(1)
                                    },
                                    children: body
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 2,
                                    sx: {
                                        paddingTop: body ? theme.spacing(1) : 0
                                    },
                                    children: [
                                        collection.games.map(function(game, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                                xs: breaks.xs,
                                                sm: breaks.sm,
                                                md: breaks.md,
                                                lg: breaks.lg,
                                                item: true,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Card */.Zb, {
                                                    href: "".concat(enabled ? "#" : "/game/".concat(game.slug)),
                                                    src: "".concat(assetUrl).concat(game.images.cover16x9 || game.images.cover, "/"),
                                                    alt: game.name || "Cover",
                                                    title: game.name || undefined,
                                                    description: game.description || undefined,
                                                    width: componentOptions.component_card_width || 512,
                                                    height: componentOptions.component_card_height || 288,
                                                    sizes: "".concat(theme.breakpoints.up("lg").replace("@media ", ""), " 16.666vw, ").concat(theme.breakpoints.up("md").replace("@media ", ""), " 25vw, ").concat(theme.breakpoints.up("sm").replace("@media ", ""), " 33.333vw, 50vw"),
                                                    layout: "responsive",
                                                    template: cardType || types_enum/* CardTypeEnum.SIMPLE */.mq.SIMPLE,
                                                    priority: index === 0
                                                }, game.name)
                                            }, game.id || index);
                                        }),
                                        !hideEmptyCards && (0,_to_consumable_array/* default */.Z)(Array(emptyItems)).map(function(item, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                                xs: breaks.xs,
                                                sm: breaks.sm,
                                                md: breaks.md,
                                                lg: breaks.lg,
                                                item: true,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, {
                                                    elevation: 1
                                                })
                                            }, index);
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    inView && Array.isArray(global.popular) && global.popular.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection.CollectionSection, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                component: "h2",
                                variant: "h2",
                                children: t("popular_header", "Popular")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                padding: theme.spacing(2),
                                items: global.popular,
                                cardOptions: {
                                    width: componentOptions.component_card_width || 512,
                                    height: componentOptions.component_card_height || 288,
                                    sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                    layout: "responsive",
                                    template: "simple",
                                    typographyOptions: {
                                        align: "center"
                                    }
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/CollectionC/index.ts



/***/ }),

/***/ 5939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DynamicPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/containers/CollectionC/index.ts + 1 modules
var CollectionC = __webpack_require__(7405);
;// CONCATENATED MODULE: ./src/generated/category/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionC/* CollectionC */.$, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 5 modules
var BaseLayout = __webpack_require__(2176);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 13 modules
var esm = __webpack_require__(2714);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 4 modules
var AppContext = __webpack_require__(6242);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(8751);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(5613);
;// CONCATENATED MODULE: ./src/pages/category/[slug].tsx












var __N_SSG = true;
function DynamicPage(props) {
    var ref, ref1, ref2, ref3;
    var title = props.title, collection = props.collection;
    var ref4 = (0,esm/* useTranslation */.$G)([
        "common",
        "category"
    ]), t = ref4.t, i18n = ref4.i18n;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref5 = appContext.useConfig(), name = ref5.name, assetAbsoluteUrl = ref5.assetAbsoluteUrl;
    var router = (0,next_router.useRouter)();
    var paths = (0,localize_helpers/* getLocalizedPaths */.mT)(router);
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.pageContext), {
        paths: paths
    });
    var seoTitle = i18n.exists("category:title", {
        fallbackLng: props.pageContext.locale
    }) ? t("category:title", {
        title: title
    }) : t("common:title", {
        title: title
    });
    var seoDescription = i18n.exists("category:description", {
        fallbackLng: props.pageContext.locale
    }) ? t("category:description", {
        title: title,
        description: collection.description
    }) : t("common:description", {
        title: title,
        description: collection.description
    });
    var seoContent = "";
    var seoFAQSchema = ";";
    // Customized SEO
    var seo = appContext.useSeo().seo;
    // Categories page
    if (seo === null || seo === void 0 ? void 0 : seo.categories) {
        var ref6;
        var currentPageSEO = (ref6 = seo.categories) === null || ref6 === void 0 ? void 0 : ref6[router.query.slug];
        if (currentPageSEO && router.locale) {
            var seoCurrentLanguage = currentPageSEO === null || currentPageSEO === void 0 ? void 0 : currentPageSEO[router.locale];
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title) {
                seoTitle = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title;
            }
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description) {
                seoDescription = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description;
            }
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.h1_description) {
                var ref7;
                if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.show_description) {
                    var ref8;
                    seoContent = ((ref8 = seoCurrentLanguage.h1_description) === null || ref8 === void 0 ? void 0 : ref8.content) || "";
                }
                if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : (ref7 = seoCurrentLanguage.h1_description) === null || ref7 === void 0 ? void 0 : ref7.seo) {
                    var ref9;
                    seoFAQSchema = JSON.stringify(seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : (ref9 = seoCurrentLanguage.h1_description) === null || ref9 === void 0 ? void 0 : ref9.seo) || "";
                }
            }
        }
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                title: seoTitle,
                description: seoDescription,
                openGraph: {
                    images: [
                        {
                            url: "".concat(assetAbsoluteUrl).concat(((ref = collection.games[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.cover) || ((ref2 = collection.games[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : ref3.cover1x1) || collection.images.cover1x1 || collection.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                            width: 512,
                            height: 512,
                            alt: "".concat(seoTitle),
                            type: "image/png"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* CollectionPageJsonLd */.yr, {
                name: title || seoTitle,
                hasPart: collection.games.map(function(game) {
                    return {
                        about: game.description,
                        author: {
                            name: name
                        },
                        name: game.name,
                        datePublished: game.publishedAt,
                        audience: "Internet",
                        keywords: "schema",
                        thumbnailUrl: "".concat(assetAbsoluteUrl).concat(game.images.cover1x1 || game.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                        image: "".concat(assetAbsoluteUrl).concat(game.images.cover16x9 || game.images.cover1x1 || game.images.cover, "/")
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                    return {
                        position: index + 1,
                        name: crumb.name,
                        item: crumb.href
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                pageContext: pageContextWithPaths
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                dangerouslySetInnerHTML: {
                    __html: seoContent
                },
                style: {
                    padding: "24px"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                children: seoFAQSchema
            })
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
DynamicPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: types_enum/* CollectionTypesEnum.CATEGORY */.yU.CATEGORY,
        pageContext: pageContext,
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7120,7028,5237,9072,5675,5632,5483,6267,1733,9774,2888,179], function() { return __webpack_exec__(2607); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);